import React, { useState, useEffect, useRef } from "react";
import "./InlineEditor.css";
import { IconButton, TextField } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";

interface Props {
  onClose: () => void;
  onSave?: (value: any) => Promise<void>;
  textFieldProps?: any;
  initialValue?: any;
}

export const InlineEditor = ({
  textFieldProps = {},
  onSave,
  onClose,
  initialValue = "",
}: Props) => {
  const [value, setValue] = useState<any>(initialValue);
  const [saving, setSaving] = useState<boolean>(false);
  const inputRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (!inputRef.current) {
      return;
    }

    inputRef.current.select();
  }, []);
  return (
    <div className="inline-editor">
      <div className="edit-component">
        <TextField
          disabled={saving}
          {...textFieldProps}
          value={value}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setValue(e.target.value)
          }
          margin="dense"
          inputRef={inputRef}
        />
      </div>
      <div className="icons-component">
        <IconButton
          disabled={saving}
          size="small"
          onClick={async () => {
            if (onSave) {
              setSaving(true);
              try {
                await onSave(value);
              } finally {
                setSaving(false);
                onClose();
              }
            }
          }}>
          <SaveIcon />
        </IconButton>
        <IconButton size="small" onClick={() => onClose()}>
          <CloseIcon />
        </IconButton>
      </div>
    </div>
  );
};
